export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";